import React, { memo } from 'react';
import { View } from 'react-native';

import { imgMaintenance } from '@/assets/images';
import { Image, Text } from '@/components/ui';
import { STRINGS } from '@/constants/strings';
import { createStyles, useScaling } from '@/hooks';
import { colors, guardianColors } from '@/theme/colors';

export type DefaultScreenProps = {
  title?: string;
  subtitle?: string;
};

function DefaultScreenComponent({
  title = STRINGS.common.defaultScreen.title,
  subtitle = STRINGS.common.defaultScreen.subtitle,
}: DefaultScreenProps) {
  const { scale } = useScaling();
  const styles = useStyles();

  return (
    <View style={styles.root}>
      <View style={styles.content}>
        <View style={styles.iconCircle}>
          <Image source={imgMaintenance} width={scale(80)} height={scale(80)} />
        </View>

        <Text
          numberOfLines={2}
          variant="Font Guardian App/Heading/Heading H6 18px"
          style={styles.title}>
          {title}
        </Text>
        <Text numberOfLines={1} variant="Font Inter/Subtitle/Medium 12px" style={styles.subtitle}>
          {subtitle}
        </Text>
      </View>
    </View>
  );
}

const useStyles = createStyles(({ scale }) => ({
  root: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors['1'],
    paddingHorizontal: scale(24),
  },
  content: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingBottom: scale(36),
  },
  iconCircle: {
    width: scale(160),
    height: scale(160),
    borderRadius: scale(80),
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#346AE10A',
    marginBottom: scale(32),
  },
  title: {
    color: colors['Labels/Primary'],
    textAlign: 'center',
  },
  subtitle: {
    color: guardianColors['6'],
    marginTop: scale(20),
    textAlign: 'center',
    textTransform: 'uppercase',
  },
}));

export const DefaultScreen = memo(DefaultScreenComponent);
